import OnLoadHelper from '@/scripts/old/helpers/OnLoadHelper';
import { findClosestElement, parseAttr } from '@/scripts/old/helpers/utils';

const NAMESPACE = 'data-social-share';

// https://github.com/bradvin/social-share-urls

class ScrollToModule {
  constructor() {
    this.initialized = false;

    this.onClickShim = (e) => {
      this.onClick(e);
    };

    OnLoadHelper.run(() => {
      this.init();
    });
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    this.setEvents();
  }

  update() {
    this.init();
  }

  destroy() {
    this.setEvents(false);
    this.initialized = false;
  }

  setEvents(add = true) {
    const action = add ? 'addEventListener' : 'removeEventListener';
    document[action]('click', this.onClickShim);
  }

  onClick(e) {
    const trigger = findClosestElement(e.target, `[${NAMESPACE}]`);

    if (trigger) {
      e.preventDefault();

      const config = parseAttr(trigger, NAMESPACE);

      let target;
      let url;
      let title;
      let description;
      let image;

      if (typeof config === 'string') {
        target = config;
        url = document.location.href;
      } else {
        target = config.target;
        url = config.url || document.location.href;
        title = config.title ? encodeURIComponent(config.title) : '';
        description = config.description ? encodeURIComponent(config.description) : '';
        image = config.image ? encodeURIComponent(config.image) : '';
      }

      url = encodeURIComponent(url);

      switch (target) {
        case 'vk': {
          let sharerUrl = `https://vk.com/share.php?url=${url}`;

          if (title) {
            sharerUrl += `&title=${title}`;
          }

          if (description) {
            sharerUrl += `&description=${description}`;
          }

          if (image) {
            sharerUrl += `&image=${image}`;
          }

          this.openWindow(sharerUrl);
          break;
        }
        case 'fb': {
          let sharerUrl = `https://facebook.com/sharer/sharer.php?u=${url}`;

          if (title) {
            sharerUrl += `&t=${title}`;
          }

          this.openWindow(sharerUrl);
          break;
        }
        case 'ok': {
          let sharerUrl = `https://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1&st._surl=${url}`;

          if (title) {
            sharerUrl += `&st.comments=${title}`;
          }

          this.openWindow(sharerUrl);
          break;
        }
        case 'tw': {
          let sharerUrl = `http://twitter.com/share?url=${url}`;

          if (title) {
            sharerUrl += `&text=${title}`;
          }

          this.openWindow(sharerUrl);
          break;
        }
        default:
          console.warn('Target social network not supported');
          break;
      }
    }
  }

  openWindow(url) {
    return window.open(url, '', `width=640,height=480,left=${(window.screen.width - 640) / 2},top=${(window.screen.height - 480) / 2},location=no,toolbar=no,menubar=no,scrollbars=1`);
  }
}

export default new ScrollToModule();
